var map = {
	"./CERAVE.jpg": 6315,
	"./LA-ROCHE-POSAY.jpg": 6316,
	"./ROGER&GALLET.jpg": 6317,
	"./Sanoflore.jpg": 6318,
	"./SkinCeuticals.jpg": 6319,
	"./VICHY.jpg": 6320,
	"./logo-essity.png": 426
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6314;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo ^\.\/.*$
// module id = 6314
// module chunks = 0